import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {isSmallScreen} from "../../../../UtilsLib";


export class InlineUserDashboardTabStyle extends StyleSheet {
    @styleRule
    tab = {
        minHeight: "100%",
        padding: "12px 24px",
        background: this.themeProps.WHITE,
        fontSize: isSmallScreen() ? this.themeProps.MERCHANT_FONT_SIZE_SMALL : this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
    };

    @styleRule
    button = {
        width: 191,
    };

    @styleRule
    textSection = {
        margin: "8px 0",
        ":>last-child": {
            marginBottom: 0,
        }
    };

    @styleRule
    link = this.themeProps.PAYWALL_LINK;
}

@registerStyle(InlineUserDashboardTabStyle)
export class InlineUserDashboardTab extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.tab);
    }
}
